import { render, staticRenderFns } from "./ArticleSuppliers.vue?vue&type=template&id=fffe7e1c&scoped=true&"
import script from "./ArticleSuppliers.vue?vue&type=script&lang=js&"
export * from "./ArticleSuppliers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffe7e1c",
  null
  
)

export default component.exports